import axios from 'axios'
import { Message } from 'element-ui'
import config from '@/config/env'

const service = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {},
  timeout: 60000
})

function normalizeAuthToken (rawToken) {
  if (!rawToken || rawToken === 'null' || rawToken === 'undefined') {
    return ''
  }
  const token = String(rawToken).trim()
  if (!token) {
    return ''
  }
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`
}

export function getAuthToken () {
  return normalizeAuthToken(sessionStorage.getItem('token'))
}

export function getUploadHeaders () {
  const token = getAuthToken()
  return token ? { Authorization: token } : {}
}

service.interceptors.request.use(
  (reqConfig) => {
    const token = normalizeAuthToken(sessionStorage.getItem('token'))
    if (token) {
      reqConfig.headers['Authorization'] = token
    }
    const litemallToken = localStorage.getItem('X-Litemall-Token')
    if (litemallToken && typeof litemallToken === 'string' && litemallToken !== '[object Object]') {
      reqConfig.headers['X-Litemall-Token'] = litemallToken
    }
    if (/get/i.test(reqConfig.method)) {
      reqConfig.params = reqConfig.params || {}
      reqConfig.params.temp = Date.parse(new Date()) / 1000
    }
    return reqConfig
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.errorCode === '3003' || res.errorCode === '3001') {
      if (window.location.hash !== '#/login') {
        const flag = sessionStorage.getItem('flag')
        sessionStorage.clear()
        if (flag !== '2') {
          sessionStorage.setItem('flag', '2')
        }
        window.location.hash = '#/login'
      }
    }
    return res
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js